import { get, split } from 'lodash-es'
import {
  getlocation,
  refreshOrShare,
  setPageInfo,
  share as openShare
} from 'kwsdk'
import { http } from './http'
import { LocationType } from './location'

/* 设置标题及刷新分享 */
export function setPage({ title = '孕产·亲子', refresh = true, share = true }) {
  setPageInfo({
    title,
    refresh,
    share
  })
  if (share) {
    setShare({
      title
    })
  }
}

interface ShareConfigType {
  channel?: string //分享渠道2图文分享 5微信 6朋友圈	7新浪 3QQ 8复制链接
  imageByte?: string //图文
  title?: string // 标题
  desc?: string // 秒杀
  imgUrl?: string // 图片
  link?: string // 链接
  subtext?: string //价格
  /* 微信小程序分享设置 */
  userName?: string //小程序username
  webpageUrl?: string // 低版本网页链接
  path?: string // 小程序页面路径
  mpTitle?: string // 分享标题
  mpDescription?: string // 分享内容
  thumbUrl?: string // 分享图片
  mpType?: number // 小程序版本0正式版;1开发版;2体验版;
}
/* 设置分享信息 */
export function setShare(config: ShareConfigType = {}) {
  // 分享参数透传，详见https://note.youdao.com/ynoteshare1/index.html?id=5642808b53f6e532cc622ca932662818&type=note
  const shareObj = {
    title: '孕产·亲子',
    desc: '孩子王孕产亲子平台，为您优选品质服务',
    link: location.href,
    ...config
  }
  // 微信小程序分享设置
  const shareInfo = {
    ...shareObj,
    userName: shareObj.userName /* || 'gh_362b01c44275' */, //传userName时，微信分享会使用小程序，不传默认链接分享
    webpageUrl: shareObj.link,
    path:
      shareObj.path ||
      `pages/mall-index/index?refererH5=${encodeURIComponent(shareObj.link)}`,
    mpTitle: shareObj.title,
    mpDescription: shareObj.desc,
    thumbUrl: shareObj.imgUrl,
    mpType: 0
  }
  try {
    window.getAppShareInfo = () => shareInfo
  } catch (e) {
    console.log(e)
  }
}

/* 拉起分享面板 */
export function openShareBoard() {
  openShare()
}

interface LatLngType {
  lat: string
  lng: string
}
async function getAPPLatAndLng(): Promise<LatLngType | null> {
  try {
    const gps = await getlocation()
    if (gps && gps.code == 1 && gps.data) {
      const { lat, lng } = gps.data
      if (lat && lng) {
        return { lat, lng }
      } else {
        return null
      }
    }
    return null
  } catch (e) {
    return null
  }
}

async function convertLaL(lng: string, lat: string): Promise<any> {
  const response = await http.get(
    '//restapi.amap.com/v3/assistant/coordinate/convert',
    {
      params: {
        key: 'f314522ef593bfb914470c5bd12b9452',
        locations: `${lng},${lat}`,
        coordsys: 'baidu'
      }
    }
  )
  return response
}

/* 获取app定位的经纬度信息并转化出城市 */
export async function getAppPosition(): Promise<LocationType | null> {
  try {
    const position = await getAPPLatAndLng()
    if (position) {
      const res = await convertLaL(position.lng, position.lat)
      if (res && res.status == '1' && res.locations) {
        const locations = res.locations
        const [gdLng, gdLat] = split(locations, ',', 2)
        const response: any = await http.get(
          '//restapi.amap.com/v3/geocode/regeo',
          {
            params: {
              key: 'f314522ef593bfb914470c5bd12b9452',
              location: `${gdLng},${gdLat}`
            }
          }
        )
        if (response && response.status == '1') {
          const adcode = get(response, 'regeocode.addressComponent.adcode')
          const cityId = `${adcode.slice(0, 4)}00`
          const cityName = get(response, 'regeocode.addressComponent.city')
          return {
            cityId,
            cityName,
            adcode,
            lat: gdLat,
            lng: gdLng
          }
        }
      }
    }
    return null
  } catch (e) {
    return null
  }
}

/* 是否允许页面分享及刷新 */
export function allowRefreshOrShare(canRefresh = true, canShare = true): void {
  try {
    refreshOrShare({ canRefresh, canShare })
  } catch (e) {
    console.log(e)
  }
}
